import { ActivatedRoute } from '@angular/router';
import { Cart } from './../cart.model';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-itinerary-customer-requests-cart',
  templateUrl: './itinerary-customer-requests-cart.component.html',
  styleUrls: ['./itinerary-customer-requests-cart.component.css']
})
export class ItineraryCustomerRequestsCartComponent implements OnInit {

  cart: Cart;

  constructor(private route: ActivatedRoute) { }

  ngOnInit() {
    this.cart = this.route.parent.snapshot.data.cart;
  }
}
